export const enhanceDraftConnectorList = (draftList) => {
  return draftList.map((draft, index) => {
    const sources = draft.sources.map((source) => ({
      logo: `/assets/connector-icons/rounded-logos/${source.provider}-rounded.svg`,
      name: source.name,
    }));

    const models = draft.models.map((model) => {
      const destinations = model.destinations.map((destination) => ({
        displayName: destination.displayName,
        name: destination.name,
        logo: `/assets/connector-icons/rounded-logos/${destination.provider}-rounded.svg`,
      }));

      return {
        ...model,
        destinations,
      };
    });

    return {
      ...draft,
      name: `${draft.name}_${index}`,
      sources,
      models,
      stage: 'dev',
    };
  });
};
